module.exports = "images/miscellaneous_videogame.4019a5e2ade3fe24ff75b8d632614a40.png";